import React from 'react';
import { ReactComponent as XlsxFileIcon } from '../../assets/images/icons/xlsxFileIcon.svg';

export default function XlsxFile({ className }) {
  return (
    <XlsxFileIcon className={`icon ${className}`} />
  );
}
